export enum FinancialInstitutionType {
    BANK = 1,           // Banco
    COOPERATIVE = 2,    // Cooperativa
}